package com.hyperether.goodjob.scenes.user.components

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.lazy.rememberLazyListState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.selection.DisableSelection
import androidx.compose.material.Text
import androidx.compose.material3.Checkbox
import androidx.compose.material3.CheckboxDefaults
import androidx.compose.runtime.Composable
import androidx.compose.runtime.MutableState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateListOf
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.draw.drawBehind
import androidx.compose.ui.draw.scale
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.input.pointer.PointerIcon
import androidx.compose.ui.input.pointer.pointerHoverIcon
import androidx.compose.ui.layout.onGloballyPositioned
import androidx.compose.ui.platform.LocalDensity
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import com.hyperether.goodjob.Dp
import com.hyperether.goodjob.boxCornerShape
import com.hyperether.goodjob.log
import com.hyperether.goodjob.models.Contact
import com.hyperether.goodjob.models.Team
import com.hyperether.goodjob.models.User
import com.hyperether.goodjob.resources.Res
import com.hyperether.goodjob.resources.are_you_sure
import com.hyperether.goodjob.resources.cancel
import com.hyperether.goodjob.resources.city
import com.hyperether.goodjob.resources.confirmation
import com.hyperether.goodjob.resources.create_your_first_team
import com.hyperether.goodjob.resources.delete
import com.hyperether.goodjob.resources.email
import com.hyperether.goodjob.resources.name
import com.hyperether.goodjob.resources.phone_number
import com.hyperether.goodjob.resources.start_by_adding
import com.hyperether.goodjob.resources.status
import com.hyperether.goodjob.resources.team
import com.hyperether.goodjob.resources.teams
import com.hyperether.goodjob.scenes.components.GenericListScreen
import com.hyperether.goodjob.scenes.components.Pagination
import com.hyperether.goodjob.scenes.components.PopUpDialog
import com.hyperether.goodjob.scenes.components.SearchTeamSelectorWeb
import com.hyperether.goodjob.scenes.components.WebFilterButton
import com.hyperether.goodjob.scenes.components.WebSearchField
import com.hyperether.goodjob.scenes.components.clickableWithPointer
import com.hyperether.goodjob.scenes.components.disableMouseDragScrollOnWeb
import com.hyperether.goodjob.scenes.components.verticalScrollbar
import com.hyperether.goodjob.scenes.user.UserViewModel
import com.hyperether.goodjob.theme.BlueApp
import com.hyperether.goodjob.theme.BorderColor
import com.hyperether.goodjob.util.UserStatusHelper
import com.hyperether.goodjob.util.toScaleDp
import com.hyperether.goodjob.util.toScaleSp
import com.hyperether.resources.stringResource


@Composable
fun <T> UserListWeb(
    viewModel: UserViewModel,
    isEmployeeList: Boolean,
    title: String,
    searchTextTeam: MutableState<String>,
    allItems: List<T>,
    filteredItems: List<T>,
    sortBy: MutableState<String?>,
    searchText: MutableState<String>,
    currentPage: MutableState<Int>,
    itemsPerPage: Int,
    showFilterDialog: MutableState<Boolean>,
    deleteItemById: (String) -> Unit,
    saveSelectedItem: (String) -> Unit,
    teams: List<Team>,
    selectedTeams: MutableState<Map<String, Boolean>>,
    onCheckedChange: (String, Boolean) -> Unit,
    onTeamCreated: (String) -> Unit,
    onDeleteTeamClick: () -> Unit,
    onCalculatedItemsPerPageChanged: ((Int) -> Unit)? = null
) {
    val selectedEmployees = remember { mutableStateListOf<String>() }
    var selectedTab by remember { mutableStateOf(0) }
    var genericListScreenHeight by remember { mutableStateOf(0.dp) }

    log.d("UserListWeb") {
        "UserListWeb recompose: currentPage: ${currentPage.value} " +
                "filteredItems size: ${filteredItems.size} " +
                "allItems size: ${allItems.size} " +
                "GenericListScreen height: $genericListScreenHeight + " +
                "itemsPerPage: $itemsPerPage"
    }

    Column(
        modifier = Modifier
            .fillMaxSize()
            .padding(
                start = 75.toScaleDp(),
                end = 75.toScaleDp(),
                bottom = 15.toScaleDp()
            )
            .background(Color.White, shape = boxCornerShape())
            .border(
                width = 1.toScaleDp(),
                shape = boxCornerShape(),
                color = BorderColor
            )
    ) {
        Row(
            verticalAlignment = Alignment.CenterVertically,
            modifier = Modifier.padding(
                top = 24.toScaleDp(),
                end = 40.toScaleDp(),
                start = 24.toScaleDp()
            )
        ) {
            Column(modifier = Modifier) {
                Row {
                    TabItem(
                        label = title,
                        isSelected = selectedTab == 0,
                        onClick = {
                            if (selectedTab != 0)
                                currentPage.value = 1
                            selectedTab = 0
                        }
                    )
                    Spacer(modifier = Modifier.width(20.toScaleDp()))
                    TabItem(
                        label = stringResource(Res.string.teams),
                        isSelected = selectedTab == 1,
                        onClick = {
                            if (selectedTab != 1)
                                currentPage.value = 1
                            selectedTab = 1
                        }
                    )
                    if (selectedTab == 0) {
                        Spacer(modifier = Modifier.weight(1f))
                        WebSearchField(
                            text = searchText.value,
                            onTextChange = {
                                searchText.value = it
                                currentPage.value = 1
                            }
                        )
                        Spacer(modifier = Modifier.width(16.toScaleDp()))

                        if (allItems.isNotEmpty() || viewModel.isInFilterMode()) {
                            WebFilterButton(
                                onClick = {
                                    showFilterDialog.value = true
                                }
                            )
                        }
                        Spacer(modifier = Modifier.width(16.toScaleDp()))

                        // TODO: get options or remove
//                    DropdownSortBy(
//                        shouldAppendSortBy = true,
//                        items = listOf("Newest", "Oldest"),
//                        selectedValue = sortBy.value ?: "Newest",
//                        onValueSelected = { sortBy.value = it },
//                        displayText = { it },
//                        placeholderColor = BorderColor,
//                        textColor = Color.Black,
//                        modifier = Modifier.height(Dp(55f))
//                    )
                    } else {
                        Spacer(modifier = Modifier.weight(1f))
                        SearchTeamSelectorWeb(
                            teamsFromDb = teams,
                            onAddNewTeam = {
                                onTeamCreated(it)
                            },
                            text = searchTextTeam.value,
                            onTextChange = {
                                searchTextTeam.value = it
                                currentPage.value = 1
                            }
                        )
                    }
                }
                if (selectedTab == 1 && selectedTeams.value.isNotEmpty() && teams.isNotEmpty()) {
                    Spacer(modifier = Modifier.height(6.toScaleDp()))
                    DeleteButton(
                        onDeleteClick = {
                            viewModel.showPopUpDelete.value = true
                        }
                    )
                }
                if (selectedEmployees.isNotEmpty() && selectedTab == 0) {
                    Spacer(modifier = Modifier.height(6.toScaleDp()))
                    DeleteButton(
                        onDeleteClick = {
                            viewModel.showPopUpDelete.value = true
                        }
                    )
                }
            }
        }

        if (selectedTab == 1) {
            val filteredTeams = if (searchTextTeam.value.isNotBlank()) {
                teams.filter { team ->
                    team.name?.contains(searchTextTeam.value, ignoreCase = true) == true
                }
            } else {
                teams
            }
            val allSelected =
                selectedTeams.value.values.all { it } && selectedTeams.value.size == teams.size
            if (teams.isNotEmpty()) {
                Column(
                    modifier = Modifier.fillMaxSize()
                ) {
                    Row(
                        modifier = Modifier
                            .fillMaxWidth()
                            .background(Color.White)
                            .drawBehind {
                                val strokeWidth = Dp(1f).toPx()
                                drawLine(
                                    color = com.hyperether.goodjob.theme.Divider,
                                    start = Offset(0f, size.height - strokeWidth / 2),
                                    end = Offset(size.width, size.height - strokeWidth / 2),
                                    strokeWidth = strokeWidth
                                )
                            }
                            .padding(horizontal = 40.toScaleDp(), vertical = 16.toScaleDp()),
                        horizontalArrangement = Arrangement.SpaceBetween,
                        verticalAlignment = Alignment.CenterVertically,
                    ) {
                        Checkbox(
                            modifier = Modifier
                                .scale(1f)
                                .pointerHoverIcon(PointerIcon.Hand),
                            checked = allSelected,
                            onCheckedChange = { isChecked ->
                                selectedTeams.value =
                                    teams.mapNotNull { team -> team._id?.let { it to isChecked } }
                                        .toMap()
                                if (!isChecked) {
                                    selectedTeams.value = emptyMap()
                                }
                            },
                            colors = CheckboxDefaults.colors(
                                checkedColor = BlueApp,
                                uncheckedColor = com.hyperether.goodjob.theme.Divider
                            )
                        )
                        Spacer(modifier = Modifier.width(40.toScaleDp()))
                        Text(
                            text = stringResource(Res.string.name),
                            modifier = Modifier.weight(1.25f),
                            fontSize = 14.toScaleSp(),
                            fontWeight = FontWeight.W700,
                            maxLines = 1,
                            overflow = TextOverflow.Ellipsis
                        )
                    }
                    val startIndex = (currentPage.value - 1) * itemsPerPage
                    val endIndex =
                        (startIndex + itemsPerPage).coerceAtMost(filteredTeams.size)
                    val paginatedTeams = filteredTeams.subList(startIndex, endIndex)
                    val listState = rememberLazyListState()
                    LazyColumn(
                        state = listState,
                        modifier = Modifier
                            .verticalScrollbar(listState)
                            .weight(1f)
                            .disableMouseDragScrollOnWeb()
                    ) {
                        if (paginatedTeams.isNotEmpty()) {
                            items(paginatedTeams) { team ->
                                TeamItemWeb(
                                    text = team.name.orEmpty(),
                                    isChecked = selectedTeams.value[team._id] == true,
                                    onCheckedChange = { isChecked ->
                                        team._id?.let { onCheckedChange(it, isChecked) }
                                        if (!isChecked) {
                                            selectedTeams.value =
                                                selectedTeams.value.toMutableMap().apply {
                                                    remove(team._id)
                                                }
                                        }
                                    })
                            }
                        }
                    }
                    Pagination(
                        list = filteredTeams,
                        currentPage = currentPage.value,
                        itemsPerPage = itemsPerPage,
                        onPageChange = { page -> currentPage.value = page })
                }
            } else {
                Column(
                    modifier = Modifier.padding(
                        start = 16.toScaleDp(),
                        end = 16.toScaleDp(),
                        top = 50.toScaleDp()
                    )
                        .fillMaxWidth(), horizontalAlignment = Alignment.CenterHorizontally
                ) {
                    Text(
                        text = stringResource(Res.string.create_your_first_team),
                        fontSize = 24.toScaleSp(),
                        color = Color.Black,
                        fontWeight = FontWeight.Bold,
                        textAlign = TextAlign.Center

                    )
                    Spacer(modifier = Modifier.height(15.toScaleDp()))
                    Text(
                        text = stringResource(Res.string.start_by_adding),
                        fontSize = 16.toScaleSp(),
                        textAlign = TextAlign.Center
                    )
                    Spacer(modifier = Modifier.height(15.toScaleDp()))
                }
            }
        }

        if (selectedTab == 0) {
            val density = LocalDensity.current
            if (isEmployeeList) {
                // UserRowWeb - 62dp height
                GenericListScreen(
                    allItems = allItems,
                    items = filteredItems,
                    currentPage = currentPage,
                    itemsPerPage = itemsPerPage,
                    selectedItems = selectedEmployees,
                    saveSelectedItem = { itemId -> saveSelectedItem(itemId) },
                    getItemId = { (it as? User)?._id },
                    ItemRowHeader = { allSelected, onSelectAllChange ->
                        UserHeaderWeb(
                            allSelected = allSelected, onSelectAllChange = onSelectAllChange
                        )
                    },
                    ItemRow = { item, isSelected, onSelectionChange, modifier ->
                        UserRowWeb(
                            user = item as User,
                            isSelected = isSelected,
                            onSelectionChange = onSelectionChange,
                            modifier = modifier
                        )
                    },
                    PaginationControls = { allItems, currentPage, itemsPerPage, onPageChange ->
                        Pagination(
                            list = allItems,
                            currentPage = currentPage,
                            itemsPerPage = itemsPerPage,
                            onPageChange = onPageChange
                        )
                    },
                    modifier = Modifier.onGloballyPositioned { layoutCoordinates ->
                        genericListScreenHeight =
                            with(density) { layoutCoordinates.size.height.toDp() }
                    }
                )
            } else {
                // TODO: FOR CONTACTS
                GenericListScreen(
                    allItems = allItems,
                    items = filteredItems,
                    currentPage = currentPage,
                    itemsPerPage = itemsPerPage,
                    selectedItems = selectedEmployees,
                    saveSelectedItem = { itemId -> saveSelectedItem(itemId) },
                    getItemId = { (it as? Contact)?.id },
                    ItemRowHeader = { allSelected, onSelectAllChange ->
                        UserHeaderWeb(
                            allSelected = allSelected, onSelectAllChange = onSelectAllChange
                        )
                    },
                    ItemRow = { item, isSelected, onSelectionChange, modifier ->
//                    EmployeeRow(
//                        employee = item as Contact,
//                        isSelected = isSelected,
//                        onSelectionChange = onSelectionChange,
//                        modifier = modifier
//                    )
                    },
                    PaginationControls = { allItems, currentPage, itemsPerPage, onPageChange ->
                        Pagination(
                            list = allItems,
                            currentPage = currentPage,
                            itemsPerPage = itemsPerPage,
                            onPageChange = onPageChange
                        )
                    },
                    modifier = Modifier.onGloballyPositioned { layoutCoordinates ->
                        genericListScreenHeight =
                            with(density) { layoutCoordinates.size.height.toDp() }
                    }
                )
            }
        }

        if (viewModel.showPopUpDelete.value) {
            PopUpDialog(
                onDismiss = { viewModel.showPopUpDelete.value = false },
                title = stringResource(Res.string.confirmation),
                message = stringResource(Res.string.are_you_sure),
                onPositiveBtnClicked = {
                    viewModel.showPopUpDelete.value = false
                    if (selectedTab == 0 && selectedEmployees.isNotEmpty()) {
                        for (id in selectedEmployees) {
                            deleteItemById(id)
                        }
                        selectedEmployees.clear()
                    } else if (selectedTab == 1 && selectedTeams.value.isNotEmpty() && teams.isNotEmpty()) {
                        onDeleteTeamClick()
                        selectedTeams.value = emptyMap()
                    }
                },
                onNegativeBtnClicked = {
                    viewModel.showPopUpDelete.value = false
                },
                positiveBtnText = stringResource(Res.string.delete),
                negativeBtnText = stringResource(Res.string.cancel)
            )
        }
    }
}

@Composable
private fun DeleteButton(
    onDeleteClick: () -> Unit
) {
    DisableSelection {
        Text(
            modifier = Modifier
                .clip(RoundedCornerShape(8.toScaleDp()))
                .clickableWithPointer {
                    onDeleteClick()
                }
                .padding(vertical = 6.toScaleDp(), horizontal = 10.toScaleDp()),
            text = stringResource(Res.string.delete),
            fontSize = 14.toScaleSp(),
            fontWeight = FontWeight.W400,
            color = Color.Red,
            maxLines = 1,
            overflow = TextOverflow.Ellipsis
        )
    }
}

@Composable
private fun TabItem(
    label: String,
    isSelected: Boolean,
    onClick: () -> Unit
) {
    Box(
        modifier = Modifier
            .clip(RoundedCornerShape(8.toScaleDp()))
            .clickableWithPointer { onClick() }
            .border(
                width = 1.toScaleDp(),
                color = if (isSelected) BlueApp else Color.LightGray,
                shape = RoundedCornerShape(8.toScaleDp())
            )
            .padding(10.toScaleDp()),
        contentAlignment = Alignment.Center
    ) {
        DisableSelection {
            Text(
                text = label,
                fontSize = 20.toScaleSp(),
                color = if (isSelected) BlueApp else Color.LightGray,
                maxLines = 1,
                overflow = TextOverflow.Ellipsis
            )
        }
    }
}

@Composable
fun UserHeaderWeb(
    allSelected: Boolean,
    onSelectAllChange: (Boolean) -> Unit
) {
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .background(Color.White)
            .drawBehind {
                val strokeWidth = Dp(1f).toPx()
                drawLine(
                    color = com.hyperether.goodjob.theme.Divider,
                    start = Offset(0f, size.height - strokeWidth / 2),
                    end = Offset(size.width, size.height - strokeWidth / 2),
                    strokeWidth = strokeWidth
                )
            }
            .padding(horizontal = 40.toScaleDp(), vertical = 16.toScaleDp()),
        horizontalArrangement = Arrangement.SpaceBetween,
        verticalAlignment = Alignment.CenterVertically,
    ) {
        Checkbox(
            modifier = Modifier
                .scale(1f)
                .pointerHoverIcon(PointerIcon.Hand),
            checked = allSelected,
            onCheckedChange = onSelectAllChange,
            colors = CheckboxDefaults.colors(
                checkedColor = BlueApp,
                uncheckedColor = com.hyperether.goodjob.theme.Divider
            )
        )
        Spacer(modifier = Modifier.width(40.toScaleDp()))
        Row(
            modifier = Modifier.weight(1f),
            horizontalArrangement = Arrangement.SpaceBetween
        ) {
            Text(
                text = stringResource(Res.string.name),
                modifier = Modifier.weight(1.25f),
                fontSize = 14.toScaleSp(),
                fontWeight = FontWeight.W700,
                maxLines = 1,
                overflow = TextOverflow.Ellipsis
            )
            Text(
                text = stringResource(Res.string.team),
                modifier = Modifier.weight(1.15f),
                fontSize = 14.toScaleSp(),
                fontWeight = FontWeight.W700,
                maxLines = 1,
                overflow = TextOverflow.Ellipsis
            )
            Text(
                text = stringResource(Res.string.phone_number),
                modifier = Modifier.weight(1.15f),
                fontSize = 14.toScaleSp(),
                fontWeight = FontWeight.W700,
                maxLines = 1,
                overflow = TextOverflow.Ellipsis
            )
            Text(
                text = stringResource(Res.string.email).replaceFirstChar { if (it.isLowerCase()) it.titlecase() else it.toString() },
                modifier = Modifier.weight(1.75f),
                fontSize = 14.toScaleSp(),
                fontWeight = FontWeight.W700,
                maxLines = 1,
                overflow = TextOverflow.Ellipsis
            )
            Text(
                text = stringResource(Res.string.city),
                modifier = Modifier.weight(1f),
                fontSize = 14.toScaleSp(),
                fontWeight = FontWeight.W700,
                maxLines = 1,
                overflow = TextOverflow.Ellipsis
            )
            Box(
                modifier = Modifier.weight(1.2f)
            ) {
                Text(
                    text = stringResource(Res.string.status),
                    fontSize = 14.toScaleSp(),
                    fontWeight = FontWeight.W700,
                    maxLines = 1,
                    overflow = TextOverflow.Ellipsis
                )
            }
        }
    }
}

@Composable
fun UserRowWeb(
    user: User,
    isSelected: Boolean,
    onSelectionChange: (Boolean) -> Unit,
    modifier: Modifier = Modifier
) {
    Row(
        modifier = modifier
            .fillMaxWidth()
            .background(Color.White)
            .padding(horizontal = 40.toScaleDp())
            .drawBehind {
                val strokeWidth = Dp(1f).toPx()
                drawLine(
                    color = com.hyperether.goodjob.theme.Divider,
                    start = Offset(0f, size.height - strokeWidth / 2),
                    end = Offset(size.width, size.height - strokeWidth / 2),
                    strokeWidth = strokeWidth
                )
            }
            .padding(vertical = 16.toScaleDp())
            .pointerHoverIcon(PointerIcon.Hand),
        verticalAlignment = Alignment.CenterVertically
    ) {
        Checkbox(
            modifier = Modifier
                .scale(1f)
                .pointerHoverIcon(PointerIcon.Hand),
            checked = isSelected,
            onCheckedChange = onSelectionChange,
            colors = CheckboxDefaults.colors(
                checkedColor = BlueApp,
                uncheckedColor = com.hyperether.goodjob.theme.Divider
            )
        )
        Spacer(modifier = Modifier.width(40.toScaleDp()))
        Row(
            modifier = Modifier.weight(1f),
            horizontalArrangement = Arrangement.SpaceBetween,
            verticalAlignment = Alignment.CenterVertically
        ) {
            Text(
                text = user.getName(),
                modifier = Modifier.weight(1.25f),
                fontSize = 14.toScaleSp(),
                color = BlueApp,
                fontWeight = FontWeight.Bold,
                maxLines = 1,
                overflow = TextOverflow.Ellipsis
            )

            Text(
                text = user.teams?.joinToString(", ") { it?.value ?: " " } ?: " ",
                modifier = Modifier.weight(1.15f),
                fontSize = 14.toScaleSp(),
                maxLines = 1,
                overflow = TextOverflow.Ellipsis
            )

            Text(
                text = user.phone ?: " ",
                modifier = Modifier.weight(1.15f),
                maxLines = 1,
                overflow = TextOverflow.Ellipsis,
                fontSize = 14.toScaleSp(),
            )

            Text(
                text = user.email ?: " ",
                modifier = Modifier.weight(1.75f),
                fontSize = 14.toScaleSp(),
                maxLines = 1,
                overflow = TextOverflow.Ellipsis,
            )

            Text(
                text = user.city ?: " ",
                modifier = Modifier.weight(1f),
                fontSize = 14.toScaleSp(),
                maxLines = 1,
                overflow = TextOverflow.Ellipsis,
            )

            Box(
                modifier = Modifier
                    .height(30.toScaleDp())
                    .weight(1.2f),
                contentAlignment = Alignment.Center
            ) {
                Box(
                    modifier = Modifier
                        .height(30.toScaleDp())
                        .fillMaxWidth()
                        .border(
                            width = 1.toScaleDp(),
                            color = UserStatusHelper.getStatusColor(
                                confirmStatus = user.confirmStatus,
                                status = user.status
                            ),
                            shape = boxCornerShape()
                        ),
                    contentAlignment = Alignment.Center
                ) {
                    Text(
                        text = UserStatusHelper.getStatusText(
                            confirmStatus = user.confirmStatus,
                            status = user.status
                        ),
                        color = UserStatusHelper.getStatusColor(
                            confirmStatus = user.confirmStatus,
                            status = user.status
                        ),
                        fontSize = 14.toScaleSp(),
                        textAlign = TextAlign.Center,
                        maxLines = 1,
                        overflow = TextOverflow.Ellipsis
                    )
                }
            }
        }
    }
}
